//
// Module for the Correspondence Comments partial view
//
rs.module("framework/content/correspondence/comments",

    [/* Dependencies */],

    function () {

        var _executeSelectionChanged;

        //
        // Initialize the module
        //
        function initialize(jsSelectors, ajaxUrl, commentsGrid) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);

            // Review card selectors
            var commentsAddButton = criteria.js(jsSelectors.commentsAddButton);
            var noteUpdateToken = criteria.js(jsSelectors.noteUpdateToken);
            var unidocKey = criteria.js(jsSelectors.unidocKey);
            var unidocAssocKey = criteria.js(jsSelectors.unidocAssocKey);
            var noteEnteredBy = criteria.js(jsSelectors.noteEnteredBy);
            var noteEnteredDate = criteria.js(jsSelectors.noteEnteredDate);
            var noteEnteredByName = criteria.js(jsSelectors.noteEnteredByName);
            var noteEffectiveDate = criteria.js(jsSelectors.noteEffectiveDate);
            var commentsText = criteria.js(jsSelectors.commentsText);
            var commentsCancelButton = criteria.js(jsSelectors.commentsCancelButton);

            // Handle comments add button click event
            commentsAddButton.click(function () {

                noteUpdateToken.val('');
                unidocKey.val(-1);
                unidocAssocKey.val(-1);
                commentsText.val('');
                noteEnteredDate.val('');
                noteEnteredByName.val('');
                noteEffectiveDate.val('');

                commentsGrid.selectedValues = null;
            });

            // Handle the comments cancel button click event
            commentsCancelButton.click(function () {

                commentsGrid.selectedValues = null;
                commentsGrid.selectFirstRow();
            });

            // Handle the Comments Grid selection change event
            commentsGrid.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged && values.length > 0) {
                    $.get(
                        ajaxUrl, { unidocAssocKey: values[0] },
                        function (data) {
                            noteUpdateToken.val(data.updateToken);
                            unidocKey.val(data.unidocKey);
                            unidocAssocKey.val(data.unidocAssocKey);
                            commentsText.val(data.uniDocText);
                            noteEnteredBy.val(data.enteredBy);
                            noteEnteredByName.val(data.enteredByName);
                            noteEnteredDate.val(data.enteredDate);
                            noteEffectiveDate.val(data.effectiveDate);
                        }
                    );
                }

                _executeSelectionChanged = true;
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);